import { ChatEllipsisIcon } from 'icons/outline';
import { ContactSidebarContext } from 'features/ContactSidebar/ContactSidebarContext';
import { useContext, useState } from 'react';
import { EducatorDrawer } from 'features/EducatorProfileViews/EducatorDrawer';
import { filters } from 'features/EducatorProfileViews/ApplicantProfile/ApplicationDetails/ApplicationDetails';

export const ContactSidebarNotes = () => {
  const ctx = useContext(ContactSidebarContext);
  const notesCount = ctx.userProfileMetadata?.notes?.count;
  const lastJobApplication = ctx.lastJobApplication;
  const [openApplicantDrawer, setOpenApplicantDrawer] = useState(false);

  if (!lastJobApplication) {
    return null;
  }

  return (
    <div className="w-[275px] h-8 px-3 py-1.5 bg-slate-50 rounded-md border border-blue-600 justify-between items-start inline-flex">
      {lastJobApplication?.id && (
        <EducatorDrawer
          applicationId={lastJobApplication.id}
          initialTab={filters.APPLICANT_NOTES}
          open={openApplicantDrawer}
          onClose={() => {
            setOpenApplicantDrawer(false);
          }}
        />
      )}

      <div className="inline-flex items-center self-stretch justify-start gap-2">
        <div className="w-[18px] h-[18px] px-[2.25px] py-[3px] justify-center items-center flex">
          <div>
            <ChatEllipsisIcon className="w-5 h-5 mr-1 text-primary-pure-blue" />
          </div>
        </div>
        <div>
          <span className="text-sm font-bold text-gray-800">Internal Notes </span>
          {notesCount > 0 && (
            <span className="text-sm leading-tight text-slate-500">({`${notesCount}`})</span>
          )}
        </div>
      </div>
      <button
        className="text-sm leading-none text-blue-600 underline"
        onClick={() => setOpenApplicantDrawer(true)}
      >
        {notesCount > 0 ? 'View' : 'Add note'}
      </button>
    </div>
  );
};

ContactSidebarNotes.displayName = 'ContactSidebarNotes';
